<div class="button-wrapper">

  <div class="seperated-group">
    @if (!edit) {
      <div ngbTooltip="{{'buttons.edit' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"  triggers="hover">
        <button *checkPermission="{ role: 'editor'}" class="extra-button yellow" (click)="editForm($event)">
          <img src="assets/ico/edit.svg" alt="edit" />
        </button>
      </div>
    }
    @if (!edit && deleteItem) {
      <div ngbTooltip="{{'buttons.delete' | translate}}" tooltipClass="animation-tooltip"  triggers="hover">
        <app-modal-info title="Confirm action" [text]="deleteText" color="red" [disableDeleteConfirmButton]="disableDeleteConfirmButton"
          [isQuestion]="isQuestion" iconSrc="assets/ico/trash-alt-regular.svg" (confirmEvent)="delete()">
          <span action>
            <button *checkPermission="{ role: 'editor'}" class="extra-button red" (click)="predelete()">
              <img src="assets/ico/trash-alt-regular.svg" alt="edit" />
            </button>
          </span>
        </app-modal-info>
      </div>
    }
    @if (edit) {
      <div ngbTooltip="{{'buttons.save' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"  triggers="hover">
        <button class="extra-button green" [disabled]="disableSave || (form ? !form.dirty : false)" (click)="saveForm()">
          <img class="save" src="assets/ico/save.svg" alt="save" />
        </button>
      </div>
    }
    @if (edit) {
      <div ngbTooltip="{{'buttons.undo' | translate}}" tooltipClass="animation-tooltip" placement="top" container="body"  triggers="hover">
        @if (edit) {
          <button class="extra-button red" (click)="cancelForm()">
            <img class="undo" src="assets/ico/undo-24px.svg" alt="back" />
          </button>
        }
      </div>
    }
  </div>
</div>